import { render, staticRenderFns } from "./SliderGroup.vue?vue&type=template&id=54b364a9&scoped=true&"
import script from "./SliderGroup.vue?vue&type=script&lang=js&"
export * from "./SliderGroup.vue?vue&type=script&lang=js&"
import style0 from "./SliderGroup.vue?vue&type=style&index=0&id=54b364a9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b364a9",
  null
  
)

export default component.exports